import {Box,Button,Dialog,IconButton,Link,Stack,Typography} from '@mui/material';
import {alpha} from '@mui/material/styles';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import OpenInNewRoundedIcon from '@mui/icons-material/OpenInNewRounded';
import backgroundImageCoda from '../../core/assets/backgroundCoda.jpg';
import {CONSUMER_COLORS} from './ConsumerTheme.js';

// Lane4's own About (core Header imports custom/components/About.js). Same
// content as core's About.js - only the presentation differs: a dark navy hero
// with the Coda picture blended in (white text, so the wide display font never
// fights a pale photo) and a plain white details card underneath. The title
// stacks "Coda / Engineering" on phones instead of shrinking it to nothing.
const C=CONSUMER_COLORS;

// Locale values carry a trailing ": " for the core inline layout - drop it for the label column.
const asLabel=(text)=>(text||'').replace(/[:\s]+$/,'');

function DetailRow({label,children}){
    return (
        <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={2}
            sx={{py:1.5,'&:not(:last-of-type)':{borderBottom:'1px solid',borderColor:alpha(C.navy,0.08)}}}>
            <Typography variant="body2" sx={{color:alpha(C.navy,0.6),fontWeight:500}}>{label}</Typography>
            <Box sx={{textAlign:'right',color:C.navy,fontWeight:600,fontSize:'0.95rem'}}>{children}</Box>
        </Stack>
    );
}

const About=({aboutCallback,application})=>{
    return (
        <Dialog
            open
            onClose={aboutCallback}
            fullWidth
            maxWidth="xs"
            slotProps={{paper:{sx:{borderRadius:'20px',overflow:'hidden',m:2,width:'calc(100% - 32px)'}}}}>
            <Box
                sx={{
                    position:'relative',
                    px:3,
                    pt:3,
                    pb:3.5,
                    color:'#fff',
                    background:`radial-gradient(120% 90% at 100% 0%,${alpha(C.steelBlue,0.55)} 0%,transparent 60%),linear-gradient(160deg,${C.navy} 0%,${C.deepTeal} 100%)`,
                    '&::before':{
                        content:'""',
                        position:'absolute',
                        inset:0,
                        backgroundImage:`url(${backgroundImageCoda})`,
                        backgroundSize:'cover',
                        backgroundPosition:'center',
                        opacity:0.18,
                        mixBlendMode:'screen',
                        pointerEvents:'none',
                    },
                }}>
                <IconButton
                    aria-label={application.getLocale('ButtonClose')}
                    onClick={aboutCallback}
                    size="small"
                    sx={{position:'absolute',top:12,right:12,color:'#fff',backgroundColor:alpha('#fff',0.12),'&:hover':{backgroundColor:alpha('#fff',0.22)}}}>
                    <CloseRoundedIcon fontSize="small"/>
                </IconButton>
                <Box sx={{position:'relative'}}>
                    <Typography
                        variant="overline"
                        sx={{display:'block',color:C.cyan,letterSpacing:'0.14em',lineHeight:1.6,pr:5}}>
                        {asLabel(application.getLocale('AboutTitle'))}
                    </Typography>
                    <Typography
                        component="h2"
                        variant="h4"
                        sx={{
                            mt:0.5,
                            color:'#fff',
                            lineHeight:1.1,
                            fontSize:{xs:'1.9rem',sm:'2.1rem'},
                            overflowWrap:'anywhere',
                        }}>
                        Coda <Box component="br" sx={{display:{sm:'none'}}}/>Engineering
                    </Typography>
                    <Box sx={{mt:2,width:48,height:4,borderRadius:2,backgroundColor:C.cyan}}/>
                </Box>
            </Box>
            <Box sx={{px:3,pt:1,pb:2,backgroundColor:'#fff'}}>
                <DetailRow label={asLabel(application.getLocale('AboutPlatform'))}>Coda Core</DetailRow>
                <DetailRow label={asLabel(application.getLocale('AboutVersion'))}>2.0.0 (28.09.2025)</DetailRow>
                <DetailRow label={asLabel(application.getLocale('AboutWebsite'))}>
                    <Link
                        href="https://coda.engineering"
                        target="_blank"
                        rel="noopener noreferrer"
                        underline="hover"
                        sx={{color:C.steelBlue,fontWeight:600,display:'inline-flex',alignItems:'center',gap:0.5}}>
                        coda.engineering<OpenInNewRoundedIcon sx={{fontSize:16}}/>
                    </Link>
                </DetailRow>
                <Box sx={{display:'flex',justifyContent:'flex-end',mt:1.5}}>
                    <Button
                        variant="contained"
                        disableElevation
                        onClick={aboutCallback}
                        sx={{borderRadius:100,px:3,textTransform:'none',fontWeight:600,backgroundColor:C.navy,'&:hover':{backgroundColor:C.deepTeal}}}>
                        {application.getLocale('ButtonClose')}
                    </Button>
                </Box>
            </Box>
        </Dialog>
    );
};

export default About;
